/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateExerciseCategoryDTO,
  ExerciseCategoryDTO,
} from '../models/index';
import {
    CreateExerciseCategoryDTOFromJSON,
    CreateExerciseCategoryDTOToJSON,
    ExerciseCategoryDTOFromJSON,
    ExerciseCategoryDTOToJSON,
} from '../models/index';

export interface ExerciseCategoryCreateRequest {
    createExerciseCategoryDTO: CreateExerciseCategoryDTO;
}

export interface ExerciseCategoryDeleteRequest {
    exerciseCategoryId: string;
}

export interface ExerciseCategoryUpdateRequest {
    exerciseCategoryDTO: ExerciseCategoryDTO;
}

/**
 * 
 */
export class ExerciseCategoryApi extends runtime.BaseAPI {

    /**
     */
    async exerciseCategoryCreateRaw(requestParameters: ExerciseCategoryCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExerciseCategoryDTO>> {
        if (requestParameters['createExerciseCategoryDTO'] == null) {
            throw new runtime.RequiredError(
                'createExerciseCategoryDTO',
                'Required parameter "createExerciseCategoryDTO" was null or undefined when calling exerciseCategoryCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/exercise-category`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateExerciseCategoryDTOToJSON(requestParameters['createExerciseCategoryDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExerciseCategoryDTOFromJSON(jsonValue));
    }

    /**
     */
    async exerciseCategoryCreate(requestParameters: ExerciseCategoryCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExerciseCategoryDTO> {
        const response = await this.exerciseCategoryCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async exerciseCategoryDeleteRaw(requestParameters: ExerciseCategoryDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['exerciseCategoryId'] == null) {
            throw new runtime.RequiredError(
                'exerciseCategoryId',
                'Required parameter "exerciseCategoryId" was null or undefined when calling exerciseCategoryDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/exercise-category/{exerciseCategoryId}`.replace(`{${"exerciseCategoryId"}}`, encodeURIComponent(String(requestParameters['exerciseCategoryId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async exerciseCategoryDelete(requestParameters: ExerciseCategoryDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.exerciseCategoryDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async exerciseCategoryListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ExerciseCategoryDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/exercise-category`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ExerciseCategoryDTOFromJSON));
    }

    /**
     */
    async exerciseCategoryList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ExerciseCategoryDTO>> {
        const response = await this.exerciseCategoryListRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async exerciseCategoryUpdateRaw(requestParameters: ExerciseCategoryUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExerciseCategoryDTO>> {
        if (requestParameters['exerciseCategoryDTO'] == null) {
            throw new runtime.RequiredError(
                'exerciseCategoryDTO',
                'Required parameter "exerciseCategoryDTO" was null or undefined when calling exerciseCategoryUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/exercise-category`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ExerciseCategoryDTOToJSON(requestParameters['exerciseCategoryDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExerciseCategoryDTOFromJSON(jsonValue));
    }

    /**
     */
    async exerciseCategoryUpdate(requestParameters: ExerciseCategoryUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExerciseCategoryDTO> {
        const response = await this.exerciseCategoryUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
